import Vue from 'vue';
import VueI18n from 'vue-i18n';
import { ruleMessage } from './validatedRules';
Vue.use(VueI18n);

const messages = {
  en: {
    ...ruleMessage.en,
  },
  zhHant: {
    ...ruleMessage.zhHant,
  },
  ja: {
    ...ruleMessage.ja,
  },
  ko: {
    ...ruleMessage.ko,
  },
};

let defaultLocale;
switch (navigator.language.substring(0, 2)) {
  case 'zh':
    defaultLocale = 'zhHant';
    break;
  case 'ja':
    defaultLocale = 'ja';
    break;
  case 'ko':
    defaultLocale = 'ko';
    break;
  default:
    defaultLocale = 'en';
    break;
}

// Create VueI18n instance with options
const i18n = new VueI18n({
  locale: defaultLocale, // set locale
  messages, // set locale messages
});

export default i18n;
